import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { MessageCircle, Copy } from "lucide-react";

const SITE_URL = "https://myaveren.com/";
const WHATSAPP_MESSAGE =
    "Te comparto MYAVEREN porque creo que te puede gustar. Es una asesoría cosmética independiente que analiza tu piel y los productos que ya utilizas para ayudarte a saber qué mantener, qué revisar y qué necesitas realmente. Puedes verlo aquí: " +
    SITE_URL;

export const ReferralCard = () => {
    const shareWhatsApp = () => {
        window.open(`https://wa.me/?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`, "_blank", "noopener,noreferrer");
    };

    const copyLink = async () => {
        try {
            await navigator.clipboard.writeText(SITE_URL);
            toast.success("Enlace copiado");
        } catch {
            toast.error("No se pudo copiar el enlace");
        }
    };

    return (
        <div className="rounded-lg border border-line bg-card p-5" data-testid="referral-section">
            <h3 className="text-[16px] font-bold tracking-tight text-ink">Recomienda MYAVEREN</h3>
            <p className="mt-2 max-w-2xl text-[14px] leading-[1.6] text-subtle">
                ¿Conoces a alguien que compra cosmética sin saber realmente qué le conviene? Compártele MYAVEREN y
                ayúdale a entender mejor su piel, aprovechar lo que ya tiene y comprar solo lo que necesita.
            </p>
            <div className="mt-4 flex flex-wrap gap-3">
                <Button onClick={shareWhatsApp} size="sm" data-testid="referral-whatsapp">
                    <MessageCircle size={16} className="mr-2" />
                    Compartir por WhatsApp
                </Button>
                <Button onClick={copyLink} variant="outline" size="sm" data-testid="referral-copy">
                    <Copy size={16} className="mr-2" />
                    Copiar enlace
                </Button>
            </div>
        </div>
    );
};
